/**
 * @file    Tooltip.css
 *          Styles the tooltip widget for copying to clipboard
 * @author  Maneesh Wijewardhana <maneesh@kingsds.network>
 * @date    August 2022
 */

.tooltipContent {
  padding: 4px;
  margin-top: 2px;
  color: black;
  animation: pop-in 0.2s forwards linear;
}

.tool-tip-content-background {
  background-color: white;
  border-radius: 4px;
  box-shadow:
    rgb(0 0 0 / 5%) 0 6px 24px 0,
    rgb(0 0 0 / 8%) 0 0 0 1px;
  padding: 10px 20px;
  margin: 0;
  text-align: center;
  max-width: 350px;
}

@keyframes pop-in {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
